import Vue from 'vue';
import accountService from './index';
const failed = (error) => {
  toastr.error(error);
};

export default (context) => Vue.$http.get(`/display-banner`).then((response) => {
  if (response && response.status === 200) {
    console.log(response.data.result, '[disableBanner]');
    context.displayBanner = response.data.result;
  }
})
  .catch((error) => {
    failed(error);
  });



// WEBPACK FOOTER //
// ./src/app/services/account/disabledBanner.js